/**
 * Menu Icons + Mega Menu Enhancements
 * 1) Icones sur les liens top-level du menu
 * 2) Icones sur les sous-liens du mega menu
 * 3) Injection de contenu promo dans les panneaux mega menu
 */
(function () {
  'use strict';

  /* ============================================
     ICONES DISPONIBLES
     ============================================ */
  var svgIcons = {
    'accueil':     '<svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>',
    'cafe':        '<svg viewBox="0 0 24 24"><path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>',
    'the':         '<svg viewBox="0 0 24 24"><path d="M17 8h1a4 4 0 010 8h-1"/><path d="M3 8h14v9a4 4 0 01-4 4H7a4 4 0 01-4-4V8z"/><path d="M6 2v3M10 2v3"/></svg>',
    'abonnement':  '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    'histoire':    '<svg viewBox="0 0 24 24"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>',
    'gazette':     '<svg viewBox="0 0 24 24"><path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8M15 18h-5M10 6h8v4h-8z"/></svg>',
    'contact':     '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>',
    /* Sous-menus */
    'star':        '<svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    'best':        '<svg viewBox="0 0 24 24"><path d="M6 9H4.5a2.5 2.5 0 010-5C7 4 7 7 7 7"/><path d="M18 9h1.5a2.5 2.5 0 000-5C17 4 17 7 17 7"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0012 0V2z"/></svg>',
    'boite':       '<svg viewBox="0 0 24 24"><path d="M3 8l9-4 9 4v8l-9 4-9-4z"/><path d="M3 8l9 4 9-4"/><path d="M12 12v8"/></svg>',
    'soleil':      '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>',
    'feuille':     '<svg viewBox="0 0 24 24"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/></svg>',
    'fleur':       '<svg viewBox="0 0 24 24"><path d="M12 7.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"/><path d="M12 2a3 3 0 00-1 5.83V12M12 22a3 3 0 001-5.83V12M4.22 4.22a3 3 0 001.17 5.71L8.1 12M19.78 19.78a3 3 0 00-1.17-5.71L15.9 12M4.22 19.78a3 3 0 005.71-1.17L12 15.9M19.78 4.22a3 3 0 00-5.71 1.17L12 8.1"/></svg>',
    'capsule':     '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="6" rx="6" ry="3"/><path d="M6 6v4c0 4 2.7 7.2 6 8 3.3-.8 6-4 6-8V6"/></svg>',
    'globe':       '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15 15 0 014 10 15 15 0 01-4 10 15 15 0 01-4-10 15 15 0 014-10z"/></svg>',
    'heritage':    '<svg viewBox="0 0 24 24"><path d="M12 2l3 7h7l-5.5 4.5 2 7L12 16l-6.5 4.5 2-7L2 9h7z"/></svg>',
    'astro':       '<svg viewBox="0 0 24 24"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>',
    'specialite':  '<svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>',
    'assortiment': '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
    'grain':       '<svg viewBox="0 0 24 24"><circle cx="8" cy="10" r="3.5"/><circle cx="16" cy="10" r="3.5"/><circle cx="12" cy="16" r="3.5"/></svg>',
    'mate':        '<svg viewBox="0 0 24 24"><path d="M8 2h8l1 5H7z"/><path d="M7 7v8a5 5 0 005 5 5 5 0 005-5V7"/><path d="M17 10h3a1 1 0 011 1v2a3 3 0 01-3 3h-1"/></svg>',
    'rooibos':     '<svg viewBox="0 0 24 24"><path d="M12 22V8"/><path d="M8 6c0-2 1-4 4-4s4 2 4 4-2 3-4 4-4 2-4 4"/><path d="M16 6c0 2-1 3-4 4"/><path d="M7 17c1.5-1 3-1.5 5-1.5s3.5.5 5 1.5"/></svg>',
    'tisane':      '<svg viewBox="0 0 24 24"><path d="M17 8h1a4 4 0 010 8h-1"/><path d="M3 8h14v9a4 4 0 01-4 4H7a4 4 0 01-4-4V8z"/><path d="M7 3s1 1 1.5 0S10 2 10 3"/></svg>',
    'parfume':     '<svg viewBox="0 0 24 24"><path d="M9 3h6v2H9z"/><path d="M7 5h10v3l-1 12a2 2 0 01-2 2h-4a2 2 0 01-2-2L7 8V5z"/><path d="M12 10v4M10 12h4"/></svg>',
    'nature':      '<svg viewBox="0 0 24 24"><path d="M12 22V12"/><path d="M5 12a7 7 0 0114 0"/><path d="M5 12c0-3 2.5-6 7-9 4.5 3 7 6 7 9"/></svg>',
    'boutique':    '<svg viewBox="0 0 24 24"><path d="M3 9l1-4h16l1 4"/><path d="M3 9v11a1 1 0 001 1h16a1 1 0 001-1V9"/><path d="M9 21V13h6v8"/><path d="M5 9a2 2 0 104 0M9 9a2 2 0 104 0M13 9a2 2 0 104 0"/></svg>',
    'roue':        '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><path d="M12 2v7M12 15v7M2 12h7M15 12h7"/></svg>',
    'promo':       '<svg viewBox="0 0 24 24"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
    'cadeau':      '<svg viewBox="0 0 24 24"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>',
    'cascara':     '<svg viewBox="0 0 24 24"><path d="M12 2a7 7 0 00-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 00-7-7z"/><circle cx="12" cy="9" r="2.5"/></svg>',
    'quiz':        '<svg viewBox="0 0 24 24"><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></svg>',
    'mallette':    '<svg viewBox="0 0 24 24"><rect x="2" y="6" width="20" height="14" rx="2"/><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>'
  };

  /* ============================================
     CONFIG : Liens top-level → icone
     ============================================ */
  var topLevelIcons = {
    'accueil': 'accueil',
    'cafés': 'cafe',
    'thés & infusions': 'the',
    'abonnement': 'abonnement',
    'dasi story': 'histoire',
    'la gazette dasifrères': 'gazette',
    'contact': 'contact',
    'espace pro': 'mallette'
  };

  /* ============================================
     CONFIG : Sous-liens mega menu → icone
     Cle = texte du sous-lien (minuscule)
     ============================================ */
  var subMenuIcons = {
    /* Cafes */
    'cafés en grains/moulus':            'grain',
    'capsules compatibles nespresso®':   'capsule',
    'pures origines':                    'globe',
    'assemblages':                       'assortiment',
    'collection héritage':               'heritage',
    'collection astro café':             'astro',
    'cafés de spécialité':               'specialite',
    'nos bestsellers':                   'best',
    'assortiments de cafés':             'assortiment',
    /* Thes & infusions */
    'les boîtes de thés en métal':       'boite',
    'thés du printemps':                 'soleil',
    'cascara bliss':                     'cascara',
    'thés parfumés':                     'parfume',
    'thés natures':                      'nature',
    'matés':                             'mate',
    'rooibos':                           'rooibos',
    'tisane':                            'tisane',
    /* Dasi Story */
    'notre histoire':                    'histoire',
    'la roue des saveurs':               'roue',
    'la boutique & coffee shop':         'boutique'
  };

  /* ============================================
     REPLI PAR MOT-CLE
     Si le texte exact d'un sous-lien n'est pas dans subMenuIcons, on devine
     l'icône par mot-clé contenu. Robuste aux variantes de libellés et aux
     nouveaux groupes (ex. « Thé / Infusion », « Boîtes métal »).
     Ordre = du plus spécifique au plus générique (1er match gagne).
     ============================================ */
  var keywordIcons = [
    ['quiz', 'quiz'],
    ['espace pro', 'mallette'],
    ['espace-pro', 'mallette'],
    ['capsule', 'capsule'],
    ['grain', 'grain'],
    ['moulu', 'grain'],
    ['boîte', 'boite'],
    ['boite', 'boite'],
    ['métal', 'boite'],
    ['metal', 'boite'],
    ['cascara', 'cascara'],
    ['printemps', 'soleil'],
    ['parfum', 'parfume'],
    ['rooibos', 'rooibos'],
    ['maté', 'mate'],
    ['tisane', 'tisane'],
    ['infusion', 'feuille'],
    ['origine', 'globe'],
    ['assemblage', 'assortiment'],
    ['assortiment', 'assortiment'],
    ['héritage', 'heritage'],
    ['heritage', 'heritage'],
    ['astro', 'astro'],
    ['spécialité', 'specialite'],
    ['specialite', 'specialite'],
    ['bestseller', 'best'],
    ['best-seller', 'best'],
    ['nature', 'nature'],
    ['thé', 'the']
  ];

  function isQuizMenuContext(text, href, sectionTitle) {
    var blob = (text || '') + ' ' + (href || '') + ' ' + (sectionTitle || '');
    return blob.toLowerCase().indexOf('quiz') !== -1;
  }

  function isEspaceProMenuContext(text, href, sectionTitle) {
    var lower = ((text || '') + ' ' + (href || '') + ' ' + (sectionTitle || '')).toLowerCase();
    return lower.indexOf('espace pro') !== -1 || lower.indexOf('espace-pro') !== -1 || lower.indexOf('espacepro') !== -1;
  }

  function resolveSubIcon(text, href, sectionTitle) {
    if (isQuizMenuContext(text, href, sectionTitle)) return 'quiz';
    if (isEspaceProMenuContext(text, href, sectionTitle)) return 'mallette';
    if (subMenuIcons[text]) return subMenuIcons[text];
    for (var i = 0; i < keywordIcons.length; i++) {
      if (text.indexOf(keywordIcons[i][0]) !== -1) return keywordIcons[i][1];
    }
    return null;
  }

  /* ============================================
     INJECTION DES ICONES
     ============================================ */
  function createIcon(iconName, extraClass) {
    var svg = svgIcons[iconName];
    if (!svg) return null;
    var span = document.createElement('span');
    span.className = 'menu-icon' + (extraClass ? ' ' + extraClass : '');
    span.innerHTML = svg;
    return span;
  }

  /** Icônes prioritaires (quiz, espace pro) : remplace toute icône erronée déjà injectée. */
  var priorityPanelIcons = { quiz: true, mallette: true };

  function installPanelPriorityIcon(link, label, iconName) {
    link.querySelectorAll('.menu-icon').forEach(function (el) {
      el.remove();
    });
    var media = link.querySelector('.menu-panel__link-media');
    if (!media) {
      media = document.createElement('span');
      if (label) {
        link.insertBefore(media, label);
      } else {
        link.insertBefore(media, link.firstChild);
      }
    }
    media.className = 'menu-panel__link-media menu-panel__link-media--svg';
    media.innerHTML = svgIcons[iconName] || '';
  }

  function installSubIcon(target, iconName, extraClass) {
    target.querySelectorAll('.menu-icon').forEach(function (el) {
      el.remove();
    });
    var icon = createIcon(iconName, extraClass || 'menu-icon--sub');
    if (icon) target.insertBefore(icon, target.firstChild);
  }

  function resolveSubIconContext(el, text) {
    var anchor = el.closest ? el.closest('a') : null;
    var href = anchor ? anchor.getAttribute('href') || '' : '';
    var col = el.closest ? el.closest('.menu-panel__col, .mega-menu__column') : null;
    var sectionTitle = '';
    if (col) {
      var sec = col.querySelector('.menu-panel__sec-title, .mega-menu__link--parent');
      sectionTitle = sec ? sec.textContent || '' : '';
    }
    return resolveSubIcon(text, href, sectionTitle);
  }

  /* Marque la colonne dont le titre contient « Format » → rendu en tuiles
     (voir .mega-menu__column--formats dans mega-menu-promos.css). */
  function tagFormatColumns() {
    document.querySelectorAll('.mega-menu__column').forEach(function (col) {
      if (col.classList.contains('mega-menu__column--formats')) return;
      var parent = col.querySelector('.mega-menu__link--parent');
      if (!parent) return;
      var text = (parent.textContent || '').toLowerCase();
      if (text.indexOf('format') !== -1) {
        col.classList.add('mega-menu__column--formats');
      }
    });
  }

  function injectMenuIcons() {
    /* --- Top-level desktop --- */
    document.querySelectorAll('.menu-list__link-title').forEach(function (span) {
      if (span.querySelector('.menu-icon')) return;
      var text = (span.textContent || '').toLowerCase().trim();
      var iconName = topLevelIcons[text];
      if (iconName) {
        var icon = createIcon(iconName);
        if (icon) span.insertBefore(icon, span.firstChild);
      }
    });

    /* --- Top-level mobile --- */
    document.querySelectorAll('.menu-drawer__menu-item--mainlist .menu-drawer__menu-item-text').forEach(function (span) {
      if (span.querySelector('.menu-icon')) return;
      var text = (span.textContent || '').toLowerCase().trim();
      var iconName = topLevelIcons[text];
      if (iconName) {
        var icon = createIcon(iconName);
        if (icon) span.insertBefore(icon, span.firstChild);
      }
    });

    /* --- Sub-menu desktop (mega menu links) --- */
    document.querySelectorAll('.mega-menu__link .wrap-text').forEach(function (span) {
      var text = (span.textContent || '').toLowerCase().trim();
      var iconName = resolveSubIconContext(span, text);
      if (!iconName) return;
      if (priorityPanelIcons[iconName]) {
        installSubIcon(span, iconName, 'menu-icon--sub');
        return;
      }
      if (span.querySelector('.menu-icon')) return;
      var icon = createIcon(iconName, 'menu-icon--sub');
      if (icon) span.insertBefore(icon, span.firstChild);
    });

    /* --- Sub-menu mobile (drawer child links) --- */
    document.querySelectorAll('.menu-drawer__menu-item--child .menu-drawer__menu-item-text').forEach(function (span) {
      var text = (span.textContent || '').toLowerCase().trim();
      var iconName = resolveSubIconContext(span, text);
      if (!iconName) return;
      if (priorityPanelIcons[iconName]) {
        installSubIcon(span, iconName, 'menu-icon--sub');
        return;
      }
      if (span.querySelector('.menu-icon')) return;
      var icon = createIcon(iconName, 'menu-icon--sub');
      if (icon) span.insertBefore(icon, span.firstChild);
    });

    /* --- Panneau app (méga-menu desktop + tiroir mobile) --- */
    document.querySelectorAll('.menu-panel__link:not(.menu-panel__link--no-icon)').forEach(function (link) {
      var label = link.querySelector('.menu-panel__link-label');
      var text = (label ? label.textContent : link.textContent || '').toLowerCase().trim();
      var href = link.getAttribute('href') || '';
      var col = link.closest('.menu-panel__col');
      var sectionTitle = col ? (col.querySelector('.menu-panel__sec-title') || {}).textContent || '' : '';
      var iconName = resolveSubIcon(text, href, sectionTitle);

      if (priorityPanelIcons[iconName]) {
        installPanelPriorityIcon(link, label, iconName);
        return;
      }

      if (link.querySelector('.menu-icon')) return;
      if (!iconName) return;
      if (link.querySelector('.menu-panel__link-media')) return;

      var icon = createIcon(iconName, 'menu-icon--sub');
      if (icon) {
        if (label) {
          label.insertBefore(icon, label.firstChild);
        } else {
          link.insertBefore(icon, link.firstChild);
        }
      }
    });

    /* --- Sub-menu desktop (mega menu CUSTOM : section mega-menu.liquid) ---
       Le texte est directement dans l'ancre <a class="mega-nav__link">,
       sans .wrap-text. */
    document.querySelectorAll('.mega-nav__link').forEach(function (link) {
      var text = (link.textContent || '').toLowerCase().trim();
      var iconName = resolveSubIconContext(link, text);
      if (!iconName) return;
      if (priorityPanelIcons[iconName]) {
        installSubIcon(link, iconName, 'menu-icon--sub');
        return;
      }
      if (link.querySelector('.menu-icon')) return;
      var icon = createIcon(iconName, 'menu-icon--sub');
      if (icon) link.insertBefore(icon, link.firstChild);
    });

    tagFormatColumns();
  }

  /* ============================================
     RUN — injection robuste, idempotente, auto-régénérante
     ============================================
     Le header Horizon est rendu via `sections 'header-group'` et le thème
     utilise les View Transitions : le menu peut arriver dans le DOM après le
     chargement, être remplacé lors d'une navigation, ou muté à l'ouverture
     du mega menu. Une injection unique sur un setTimeout fixe ratait ces cas
     (affichage intermittent). On déclenche donc l'injection sur plusieurs
     sources, en débounçant via requestAnimationFrame. Le garde-fou idempotent
     `if (... .querySelector('.menu-icon')) return;` interne à injectMenuIcons
     garantit l'absence de doublons malgré les appels multiples. */

  var rafId = null;
  function scheduleInject() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      injectMenuIcons();
    });
  }

  /* 1) Exécution immédiate (script chargé en defer → DOM parsé) + DOMContentLoaded */
  scheduleInject();
  document.addEventListener('DOMContentLoaded', scheduleInject);

  /* 2) MutationObserver : header re-rendu, mega menu ouvert, swap View Transitions */
  if (window.MutationObserver) {
    new MutationObserver(scheduleInject).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* 3) Évènements de navigation / re-rendu de section */
  window.addEventListener('pageshow', scheduleInject);
  document.addEventListener('shopify:section:load', scheduleInject);

  /* 4) Filet de sécurité borné si le header est hydraté tardivement */
  var tries = 0;
  var safetyTimer = setInterval(function () {
    injectMenuIcons();
    if (++tries >= 6) clearInterval(safetyTimer);
  }, 500);
})();
